import uploadDocsReducer from './reducers';
export { default as uploadDocsOperations } from './operations';
export { default as uploadDocsTypes } from './types';
export default uploadDocsReducer;